import * as actionTypes from '../actions/actionTypes';

const DEFAULT_STATE = {
  statsPool: {
    results: [],
    loading: true,
  },
  statsUser: {
    results: [],
    loading: true,
  },
  earnings: {
    results: {},
    loading: false,
  },
  statsLanding: {
  },
};

const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        ...DEFAULT_STATE,
        statsLanding: state.statsLanding,
      };
    case actionTypes.FETCH_STATS_POOL:
      return {
        ...state,
        statsPool: {
          ...state.statsPool,
          loading: true,
        },
      };
    case actionTypes.FETCH_STATS_USER:
      return {
        ...state,
        statsUser: {
          ...state.statsUser,
          loading: true,
        },
      };
    case actionTypes.FETCH_EARNINGS:
      return {
        ...state,
        earnings: {
          ...state.earnings,
          loading: true,
        },
      };
    case actionTypes.FETCH_STATS_POOL_SUCCESS:
      return {
        ...state,
        statsPool: {
          results: action.payload,
          loading: false,
        },
      };
    case actionTypes.FETCH_STATS_USER_SUCCESS:
      return {
        ...state,
        statsUser: {
          results: action.payload,
          loading: false,
        },
      };
    case actionTypes.FETCH_EARNINGS_SUCCESS: {
      return {
        ...state,
        earnings: {
          results: action.payload,
          loading: false,
        },
      };
    }
    case actionTypes.FETCH_STATS_LANDING_SUCCESS:
      return {
        ...state,
        statsLanding: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// /src/redux/reducers/statsReducer.js